<!-- Grid row. Default gutters are bootstrap-style: -1rem side margins on the
     row, +1rem side padding on direct vf-m-col children (defined in
     src/core/tailwind/defaultOptions.js "row").
     INVARIANT: a row whose container has NO horizontal padding MUST set the
     `no-gutters` prop — otherwise the negative margins widen the document
     past the viewport (iOS sideways-pan / zoom-out / scroll-wobble bugs).
     Check new layouts with the #vfoverflow URL flag. -->
<template>
  <div class="vf-m-row" :class="getClass">
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  tag: {
    type: String,
    default() {
      return "div";
    },
  },
  noGutters: {
    type: Boolean,
    default() {
      return false;
    },
  },
  alignV: {
    type: String,
    default() {
      return null;
    },
  },
  alignH: {
    type: String,
    default() {
      return null;
    },
  },
});

const getAlignV = {
  start: "--align-v-start",
  center: "--align-v-center",
  end: "--align-v-end",
};

const getAlignH = {
  start: "--align-h-start",
  center: "--align-h-center",
  end: "--align-h-end",
};

const getClass = computed(() => {
  const result = [];

  if (props.noGutters) {
    result.push("--no-gutter");
  }

  if (props.alignV) {
    result.push("--align-v-" + props.alignV);
  }

  if (props.alignH) {
    result.push("--align-h-" + props.alignH);
  }

  return result.join(" ");
});
</script>
